var map = {
	"./assistant-active.png": 2693,
	"./assistant.png": 8136,
	"./bbs-active.png": 4427,
	"./bbs.png": 2373,
	"./blibli-active.png": 4178,
	"./blibli.png": 3892,
	"./btn-active.png": 6053,
	"./btn.png": 4932,
	"./cancel-active.png": 3114,
	"./cancel.png": 5430,
	"./edit-active.png": 6037,
	"./edit.png": 7714,
	"./home-active.png": 6593,
	"./home.png": 3362,
	"./prize-active.png": 7505,
	"./prize.png": 3147,
	"./qq-active.png": 7012,
	"./qq.png": 4540,
	"./service-active.png": 9650,
	"./service.png": 33,
	"./submit-active.png": 6266,
	"./submit.png": 9791,
	"./tieba-active.png": 5452,
	"./tieba.png": 9306,
	"./weixin-active.png": 4552,
	"./weixin.png": 1417,
	"./wenjuan-active.png": 5865,
	"./wenjuan.png": 7303
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3189;